module.exports = __webpack_public_path__ + "img/icon-phone.a76dc282.svg";